import { Record, Set, Map } from 'immutable';
import { DataModelState, RequestDiffRecord } from '../shared';


const workflowStateRecord = Record({
  entities: Map<string, any>(),
  diff: new RequestDiffRecord(),
  isBusy: 0
});

export class WorkflowState extends workflowStateRecord implements DataModelState {
  ids: Set<string>;
  entities: Map<string, any>;
  diff: RequestDiffRecord;
  relationships: undefined;
  isBusy: number;
}
